import { createRoute, Link } from '@tanstack/react-router';
import { AppBreadcrumbs } from '@/components/app/app-breadcrumbs.tsx';
import { usePageProps } from '@/hooks/use-page-props.ts';
import { Button } from '@/components/ui/button.tsx';
import { InstallationsGrid } from '@/app/pages/installations-grid.tsx';
import { layoutRoute } from '@/router/root-routes.tsx';
import { installations } from '@/app/pages/installations.ts';

export const residentialRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/installations-residential',
  component: ResidentialPage,
});

const residential = installations.filter((i) => i.type === 'residential');

function ResidentialPage() {
  usePageProps({ title: 'Residential Installations' });
  return (
    <div className="max-w-8xl mx-auto px-4">
      <AppBreadcrumbs items={[{ text: 'Home', href: '/' }, { text: 'Residential Installations' }]} />
      <h1 className="uppercase text-center mb-8">Residential Installations</h1>
      <InstallationsGrid items={residential} />
      <div className="text-center my-4 md:my-8">
        <Button asChild className="uppercase">
          <Link to="/installations-hospitality" viewTransition={true}>
            View Hospitality Installations
          </Link>
        </Button>
      </div>
    </div>
  );
}
